module.exports = __webpack_public_path__ + "static/media/Rename.24075149.svg";